import { ContextType } from "@/services/bedrock/dtos/DesignPackage";

const ALL: ContextType[] = ["review", "player", "none"];

export const LOADING_TIPS: { text: string; appliesTo: ContextType[] }[] = [
  { text: "Try “Overlap the player's headshot on the quote card” as your first refinement.", appliesTo: ALL },
  {
    text: "Ask for “a version that uses each branch's colors and logo” to see the theme switcher shine.",
    appliesTo: ALL,
  },
  { text: "Carousels can end with a call-to-action slide showing the player's profile.", appliesTo: ALL },
  { text: "You can refine one slide at a time or all slides at once.", appliesTo: ALL },
  {
    text: "Publishing creates a prompt in your library. Players see it personalized with their own branding.",
    appliesTo: ALL,
  },
  {
    text: "Players can share one review or several in a carousel. Say “highlight the best phrase” to make quotes pop.",
    appliesTo: ["review"],
  },
  { text: "Every post is rendered from the exact design you approve. Nothing gets redrawn.", appliesTo: ALL },
];
